<template>
  <button
    :disabled="btnDisabled"
    class="primary-solid"
    @click="$emit('click')"
  >
    <ns-icon icon-name="icon-cart-trans-plus" size="icon-lg" />
    {{btnText}}
  </button>
</template>

<script>
import {events, StringService} from '@nuskin/ns-util'
import {NsIcon} from '@nuskin/ns-icon'

const NONE = 'none'
const PRE = 'pre'
const IN = 'in'
const POST = 'post'
const PAUSED = 'paused'

export default {
  name: 'EventButton',

  components: {
    NsIcon
  },

  props: {
    qualification: Object,
    product: Object
  },

  data() {
    return {
      addToCartTxt: '',
      eventNotStartedTxt: '',
      eventOverTxt: '',
      eventPausedTxt: '',
      eventState: NONE,
      listenersActive: false
    }
  },

  computed: {
    btnText() {
      return this.eventState === NONE ? this.addToCartTxt :
        this.eventState === PRE ? this.eventNotStartedTxt || this.addToCartTxt :
          this.eventState === IN ? this.addToCartTxt :
            this.eventState === PAUSED ? this.eventPausedTxt || this.addToCartTxt :
              this.eventState === POST ? this.eventOverTxt || this.addToCartTxt :
                ''
    },

    btnDisabled() {
      return !((this.eventState === IN || this.eventState === NONE) && this.qualification && this.qualification.quantity > 0 && this.productAvailable())
    }
  },

  watch: {
    qualification() {
      this.initListeners()
    }
  },

  mounted() {
    this.setCommonStrings()
    this.initListeners()
  },

  methods: {
    initListeners() {
      if (this.qualification && this.qualification.eventName && !this.listenersActive) {
        events.getValue(events.salesevent.PRE_EVENT, this.preEvent, true)
        events.getValue(events.salesevent.IN_EVENT, this.inEvent, true)
        events.getValue(events.salesevent.POST_EVENT, this.postEvent, true)
        events.publish(events.salesevent.INIT_EVENT_TICKET, [this.qualification.eventName])
        this.listenersActive = true
      }
    },

    // Make sure the product is RELEASED_FOR_SALE before the button is active
    productAvailable() {
      if (this.product && this.product.status && this.product.status == 'RELEASED_FOR_SALE') {
        return true
      }
      return false
    },

    preEvent(eventName) {
      if (eventName === this.qualification.eventName) {
        this.eventState = PRE
      }
    },

    inEvent(eventName, paused) {
      if (eventName === this.qualification.eventName) {
        this.eventState = paused ? PAUSED : IN
      }
    },

    postEvent(eventName) {
      if (eventName === this.qualification.eventName) {
        this.eventState = POST
      }
    },

    setCommonStrings() {
      const commonStrings = [{ key: 'addToCart', dflt: 'Add to cart' }]

      StringService.getStrings(commonStrings).then((strings) => {
        this.addToCartTxt = strings.addToCart
      })

      StringService.getApplicationStrings('preview').then((content) => {
        this.eventNotStartedTxt = content.eventNotStarted
        this.eventOverTxt = content.eventOver
        this.eventPausedTxt = content.eventPaused
      })
    }
  }
}

</script>

<style scoped>

</style>
